import {Box, Link, Typography} from "@mui/material";
import {simpleDateFormatter} from "@/src/utils/dateFormatter";
import type Author from "@/src/_types/Authors/author";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import NextLink from "next/link";
import ReactHtmlParser from "react-html-parser";
import Journal from "@/src/_types/journal";

const HowToCite = (
    {
        howTociteDictionary,
        data,
        journal
    }: {
        howTociteDictionary: string;
        data: any;
        journal: Journal;
    }
) => (
    <Box
        p={1}
        my={1}
        bgcolor="info.main"
        borderRadius={2}
        role="doc-credit"
        sx={{
            '& span': {
                fontSize: '1rem'
            },
            '& a': {
                fontSize: '1rem'
            }
        }}
    >
        <Typography component="div" color="custom.infoText">
            <SpanTypography
                variant="h4"
                fontSize={'1rem'}
                fontWeight={700}
                mr={.25}
                sx={{textDecoration: "underline"}}
            >
                {
                    howTociteDictionary
                }
            </SpanTypography>
            {
                data?.authors?.slice(0, 5).map((author: Author, index: number, array: Author[]) => (
                    <SpanTypography 
                        key={`author-${index}`} 
                        mr={.25}
                    >
                        {
                            `${author.first_name
                            }${author.middle_name ? ` ${author.middle_name}` : ''
                            } ${author.last_name}${ index !== array.length ? ', ' : '' }`
                        }
                    </SpanTypography>
                ))
            }
            {
                data?.authors?.length > 5 && "et al. "
            }
            <SpanTypography mr={.25}>
                {
                    ReactHtmlParser(data?.title?.trim(", "))
                }.
            </SpanTypography>
            {
                journal.meta_data?.nlm_ta &&
                <SpanTypography mr={.25}>
                    {
                        journal.meta_data?.nlm_ta
                    }.
                </SpanTypography>
            }
            {
                data?.pub_dates?.epub &&
                <SpanTypography mr={.25}>
                    {
                        simpleDateFormatter(data?.pub_dates.epub, {year: 'numeric'})
                    };
                </SpanTypography>
            }
            <SpanTypography>
                {
                    data?.volume_name
                }({data?.issue_name}):
                {
                    data?.elocation_id ? data?.elocation_id : `${data?.first_page}-${data?.last_page}`
                }.
            </SpanTypography>
            {
                data?.doi && (
                    <>
                        <Link
                            component={NextLink}
                            href={process.env.NEXT_PUBLIC_DOI_WEBSITE_URL + data.doi} target="_blank" rel="noopener">
                            {process.env.NEXT_PUBLIC_DOI_WEBSITE_URL + data.doi}
                        </Link>
                        .
                    </>
                )
            }
        </Typography>
    </Box>
)

export default HowToCite;